export const capitalize = (s: string) =>
    (s && s[0].toUpperCase() + s.slice(1)) || ''

/** fills `{name}` placeholders: `fill('{n} online', { n: 3 })` → `'3 online'` */
export const fill = (
    template: string,
    values: Record<string, string | number | undefined>,
) => template.replace(/{(\w+)}/g, (_, key: string) => String(values[key] ?? ''))
